// How long something has been in the making ("Designing… 0:42 · about 0:20
// left"), for graphic plates. How long each step usually takes comes from the
// server (the last plates made there), with the gallery's list.
import { useState, useEffect } from 'react';

/** The time now, ticking every second while `on`. */
export function useNow(on) {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    if (!on) return undefined;
    setNow(Date.now());
    const timer = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(timer);
  }, [on]);
  return now;
}

const clock = (s) => `${Math.floor(s / 60)}:${String(Math.max(0, Math.round(s % 60))).padStart(2, '0')}`;

/** m:ss from an ISO time to `now`. */
export const since = (iso, now) => clock(Math.max(0, Math.floor((now - (Date.parse(iso) || now)) / 1000)));

// Seconds each step usually takes: design, change, people, animation (the server's, once the gallery has loaded).
let ESTIMATES = { design: 60, change: 50, people: 60, animation: 15 };
export const setEstimates = (next) => { if (next) ESTIMATES = { ...ESTIMATES, ...next }; };

/**
 * What is left of a step started at `iso` (step: design | change | people |
 * animation; extra: seconds before it, e.g. the design before the animation):
 * { left: 'm:ss' } — or { late: true } once it runs past the usual time.
 */
export function remaining(iso, now, step, extra = 0) {
  const elapsed = (now - (Date.parse(iso) || now)) / 1000;
  const total = (ESTIMATES[step] || 30) + extra;
  const left = total - elapsed;
  return left > 0 ? { left: clock(Math.ceil(left)) } : { late: true };
}

/** "0:42 · about 0:20 left" (or "· taking longer than usual"): t is the page's translator. */
export function etaText(t, iso, now, step, extra = 0) {
  const r = remaining(iso, now, step, extra);
  return `${since(iso, now)} · ${r.late ? t('plateTemplates.eta.late') : t('plateTemplates.eta.left', { left: r.left })}`;
}
